
export const addressView = (currentData) => {
  if (!currentData || !currentData.content) return ''
  const content = []
  Object.values(currentData.content).forEach(v => {
    if (v) {
      content.push(v)
    }
  })
  return content.join(', ')
}
